import {autoinject} from 'aurelia-framework';
import {AuthService} from "../../DataAccessLayer/Services/AuthService";

export interface EventParams {
    event_category?: string;
    event_label?: string | null;
    value?: number | null;
}

export interface PageViewParams {
    page_path: string;
    page_title?: string;
    page_location: string;
    user_id?: string | null;
}

gtag;

@autoinject
export class AnalyticsService {

    private readonly isInitialized: boolean;
    private userId: string | number | null = null;
    private authService: AuthService;

    constructor(authService: AuthService) {
        this.isInitialized = typeof gtag !== 'undefined';
        this.authService = authService;
    }

    public trackPageView(path: string, title?: string | null): void {
        if (!this.isInitialized) {
            return;
        }
        const page = path.startsWith('#') ? path : `#${path}`;
        const params: PageViewParams = {
            page_path: page,
            page_title: title || document.title,
            page_location: window.location.href
        };
        this.userId = this.authService.GetUserInfo()['UserId'];
        if (this.userId) {
            params.user_id = String(this.userId);
        }
        gtag('event', 'page_view', params);
    }

    public trackEvent(action: string, category: string = 'General', label?: string | null, value?: number | null): void {
        if (!this.isInitialized) {
            return;
        }
        const eventParams: EventParams = {
            event_category: category
        };
        if (label !== undefined) {
            eventParams.event_label = label;
        }
        if (value !== undefined) {
            eventParams.value = value;
        }
        gtag('event', action, eventParams);
    }

    public setUserId(userId: string): void {
        this.userId = userId;
        if (!this.isInitialized) {
            return;
        }
        gtag('config', 'G-EN6L74GBJ2', {
            user_id: userId
        });
    }

    public isReady(): boolean {
        return this.isInitialized;
    }
}
